module.exports = __webpack_public_path__ + "img/monyback-icon.cfd725d5.svg";